import { render, staticRenderFns } from "./dialogErrore.vue?vue&type=template&id=05454c01"
import script from "./dialogErrore.vue?vue&type=script&lang=js"
export * from "./dialogErrore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports